// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5125":"dfec154d","7936":"fa64cd68","9427":"22b668be"}[chunkId] + ".chunk.css";
};